import { CourseMaster } from "./CourseMaster.model";
import { User } from "./User.model";

export class CourseHistory{
    public courseMaster:CourseMaster;
    public user:User;
}